import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { validateValue } from '../../../utils/helpers';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Button from '@mui/material/Button';
import { api } from '../../../api/config';
import Typography from '@mui/material/Typography'
import WaitingLoader from '../../../components/general/loader/WaitingLoader';
import { useSelector } from 'react-redux';
import Alert from '@mui/material/Alert';
export default function Form() {
    const language = useSelector(state => state.language.language);
    const [active, setActive] = useState(false);
    const [loading, setLoading] = useState(false);
    const [checkAllowedEmail, setCheckAllowedEmail] = useState({ checkAllowedEmail: true });
    const [alert, setAlert] = useState({ open: false, message: '', severity: '' });
    const checkData = () => {
        setLoading(true);
        api.post('admin/checkSetting', { setting: 1 })
            .then(res => {
                setActive(res?.data?.data?.settingActive);
                setCheckAllowedEmail({ ...checkAllowedEmail, checkAllowedEmail: JSON.parse(res?.data?.data?.settingData)?.checkAllowedEmail });
            })
            .finally(() => {
                setLoading(false);
            })
    }

    useEffect(() => {
        checkData();
        //eslint-disable-next-line
    }, [])

    const [formData, setFormData] = React.useState({ firstname: '', lastname: '', dob: '', gender: '', country: '', city: '', address: '', email: '', phone: ''});

    const [error, setError] = useState({ firstname: false, lastname: false, dob: false, gender: false, country: false, city: false, address: false, email: false, phone: false });

    const inputs = {
        firstname: (e) => {
            const value = e.target.value;
            setError({ ...error, firstname: validateValue(value, /^[a-zA-Z]+$/) });
            setFormData({ ...formData, firstname: value });
        },
        lastname: (e) => {
            const value = e.target.value;
            setError({ ...error, lastname: validateValue(value, /^[a-zA-Z]+$/) });
            setFormData({ ...formData, lastname: value });
        },
        dob: (e) => {
            const value = e.target.value;
            setError({ ...error, dob: validateValue(value, /^\d{4}-\d{2}-\d{2}$/) });
            setFormData({ ...formData, dob: value });
        },
        gender: (e) => {
            const value = e.target.value;
            setError({ ...error, gender: validateValue(value, /^(M|F)$/) });
            setFormData({ ...formData, gender: value });
        },
        country: (e) => {
            const value = e.target.value;
            setError({ ...error, country: validateValue(value, /^[A-Za-z\s-]+$/) });
            setFormData({ ...formData, country: value });
        },
        city: (e) => {
            const value = e.target.value;
            setError({ ...error, city: validateValue(value, /^[A-Za-z\s-]+$/) });
            setFormData({ ...formData, city: value });
        },
        address: (e) => {
            const value = e.target.value;
            setError({ ...error, address: validateValue(value, /^[A-Za-z0-9\s,.-]+$/) });
            setFormData({ ...formData, address: value });
        },
        email: (e) => {
            const value = e.target.value;
            setError({ ...error, email: validateValue(value, /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/) });
            setFormData({ ...formData, email: value });
        },
        phone: (e) => {
            const value = e.target.value;
            setError({ ...error, phone: validateValue(value, /^(?:\+?(\d{1,3}))?[\s.-]?\(?\d+\)?[\s.-]?\d+[\s.-]?\d+$/) });
            setFormData({ ...formData, phone: value });
        },
    };

    const handleEmailCheck = (e) => {
        e.preventDefault();
        // Check for errors
        const hasError = Object.values(error).some((err) => err === true);
        if (hasError) {
            alert('Please fill all fields correctly.');
        }
        if (!hasError) {
            setLoading(true);
            api.post('/admin/checkAllowedEmail', { email: formData.email, setting: 1 })
                .then(res => {
                    setCheckAllowedEmail({ ...checkAllowedEmail, checkAllowedEmail: !res?.data?.success });
                })
                .catch(err => { })
                .finally(() => {
                    setLoading(false);
                })
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        // Check for errors
        const hasError = Object.values(error).some((err) => err === true);
        if (hasError) {
            alert('Please fill all fields correctly.');
        }
        if (!hasError) {
            setLoading(true);
            api.post('/email/confirmEmail', formData)
            .then(res => {
                if (res?.data?.success) {
                    setFormData({ firstname: '', lastname: '', dob: '', gender: '', country: '', city: '', address: '', email: '', phone: ''});
                    setError({ firstname: false, lastname: false, dob: false, gender: false, country: false, city: false, address: false, email: false, phone: false });
                }
                setAlert({ open: true, message: res?.data?.message[language], severity: res?.data?.severity });
            })
            .catch(err => { })
            .finally(() => {
                setTimeout(() => {
                    setAlert({ open: false, message: '', severity: '' });
                }, 3000)
                setLoading(false);
            })
        }
    }

    return (
        <Box minHeight={'100vh'} sx={{ backgroundColor: '#FFF', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
            {loading && <WaitingLoader open={loading} />}
            {active ?
                (
                    checkAllowedEmail.checkAllowedEmail ?
                        <Box sx={{ display: 'grid', gridTemplateRows: '1fr', rowGap: '20px', padding: '20px', width: { md: '300px', xs: '80%' }, marginX: 'auto' }}>
                            <Box component={'img'} src='https://hyper-active.com/images/2025/04/hyper-dark.svg' height={'100px'} width={'100px'} sx={{ justifySelf: 'center' }} />
                            <InputLabel>Email</InputLabel>
                            <TextField fullWidth value={formData.email} onChange={inputs.email} error={error.email} />
                            <Button fullWidth variant='contained' onClick={handleEmailCheck}>
                                Submit
                            </Button>
                        </Box>
                        :
                        <Box sx={{ display: 'grid', gridTemplateRows: '1fr', rowGap: '20px', padding: '20px', width: { md: '500px', xs: '80%' }, marginX: 'auto' }}>
                            <Box component={'img'} src='https://hyper-active.com/images/2025/04/hyper-dark.svg' height={'100px'} width={'100px'} sx={{ justifySelf: 'center' }} />
                            <Box>
                                <InputLabel>Firstname</InputLabel>
                                <TextField fullWidth value={formData.firstrname} onChange={inputs.firstname} error={error.firstname} />
                            </Box>

                            <Box>
                                <InputLabel>Lastname</InputLabel>
                                <TextField fullWidth value={formData.lastname} onChange={inputs.lastname} error={error.lastname} />
                            </Box>

                            <Box>
                                <InputLabel>Date of Birth</InputLabel>
                                <TextField fullWidth value={formData.dob} onChange={inputs.dob} error={error.dob} type='date' />
                            </Box>

                            {/* SELECT */}
                            <Box>
                                <InputLabel>Gender</InputLabel>
                                <FormControl fullWidth error={error.dob}>
                                    <Select
                                        value={formData.gender}
                                        onChange={inputs.gender}
                                        displayEmpty
                                    >
                                        <MenuItem value={'M'}>Male</MenuItem>
                                        <MenuItem value={'F'}>Femlale</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>

                            <Box>
                                <InputLabel>Country</InputLabel>
                                <TextField fullWidth value={formData.country} onChange={inputs.country} error={error.country} />
                            </Box>

                            <Box>
                                <InputLabel>City</InputLabel>
                                <TextField fullWidth value={formData.city} onChange={inputs.city} error={error.city} />
                            </Box>

                            <Box>
                                <InputLabel>Address</InputLabel>
                                <TextField fullWidth value={formData.address} onChange={inputs.address} error={error.address} />
                            </Box>

                            <Box>
                                <InputLabel>Email</InputLabel>
                                <TextField fullWidth value={formData.email} onChange={inputs.email} error={error.email} />
                            </Box>

                            <Box>
                                <InputLabel>Phone</InputLabel>
                                <TextField fullWidth value={formData.phone} onChange={inputs.phone} error={error.phone} />
                            </Box>


                            <Button fullWidth variant='contained' onClick={handleSubmit}>
                                Submit
                            </Button>
                        </Box>
                )
                :
                <Box>
                    <Typography variant="h3" textAlign={'center'}>Form is not avaliable</Typography>
                </Box>
            }
            {
                alert.open &&
                <Alert variant="filled" severity={alert.severity} sx={{ position: 'fixed', bottom: '20px', left: '20px', zIndex: 1000 }} onClose={() => setAlert({ ...alert, open: false })}>
                    {alert.message}
                </Alert>
            }
            
        </Box>
    )
}